import React from "react"
import Moment from "react-moment"
import Link from "next/link"
import { getStrapiMedia } from "../utils/api"
import "moment/locale/tr"

const BlogCard = ({ article }) => {
  const locale = typeof window !== "undefined" ? window.localStorage.i18nextLng : "en"
  let imageUrl
  if (article?.attributes?.image) {
    imageUrl = getStrapiMedia(article?.attributes?.image)
  } else {
    imageUrl = "/assets/images/blog-post-image-placeholder.jpeg"
  }

  return (
    <Link as={`/blog/${article?.attributes?.slug}?id=${article?.id}`} href="/blog/[id]" key={article?.attributes?.slug} passHref>
      <div className="card" key={article?.attributes?.slug}>
        <div className="">
          <div className="card__inner">
            <Link as={`/blog/${article?.attributes?.slug}?id=${article?.id}`} href="/blog/[id]">
              {imageUrl && (
                <img
                  src={imageUrl ?? "/acapulco.png"}
                  width="100%"
                  style={{ cursor: "pointer", height: "auto" }}
                />
              )}
              {/* <div className="link link--category">{article.category?.name}</div> */}
            </Link>
            {/* <span className="card__date">January 23, 2020</span> */}

            <i className="icon icon-2 far fa-long-arrow-right"></i>
            <div id="title" className="card__title">
              {article?.attributes?.title}
            </div>
            <div className="card__meta">
              {article?.attributes?.author ? (
                <span>
                  {article?.attributes?.author?.data?.attributes?.name}
                  {" | "}
                </span>
              ) : null}
              <Moment format="Do MMMM, YYYY dddd" className="card__date" locale={locale}>
                {article?.attributes?.created_at}
              </Moment>
            </div>
            <span className="card__description">{article?.attributes?.description}</span>

            <Link as={`/blog/${article?.attributes?.slug}?id=${article?.id}`} href="/blog/[id]" passHref>
              <div className="link link--text card__link">Okumaya devam et</div>
            </Link>
          </div>
        </div>
        <hr className="card__divider" />
      </div>
    </Link>
  )
}

export default BlogCard
